'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import OkvedsController from "./controller/okveds";
import OkvedModalCreateController from "./controller/okvedModalCreate";
import OkvedModalSelectController from "./controller/okvedModalSelect";
import OkvedTableDirective from "./directive/okvedTable";
import OkvedTreeDirective from "./directive/okvedTree";
import OkvedNodeDirective from "./directive/okvedNode";
import OkvedSelectDirective from "./directive/okvedSelect";
import OkvedService from "./service/okved";

export default angular.module('investmentProject.okvedMulti', [])
    .controller('OkvedsMultiController', OkvedsController)
    .controller('OkvedMultiModalCreateController', OkvedModalCreateController)
    .controller('OkvedMultiModalSelectController', OkvedModalSelectController)
    .directive('okvedMultiTable', OkvedTableDirective)
    .directive('okvedMultiTree', OkvedTreeDirective)
    .directive('okvedMultiNode', OkvedNodeDirective)
    .directive('okvedMultiSelect', OkvedSelectDirective)
    .factory('OkvedMultiService', OkvedService)
    .name;